/**
 * Stripe dashboard deep-link helpers.
 *
 * The Stripe dashboard host and its test-mode path segment are fixed, well-known
 * constants — not deployment configuration — so we derive the correct base from
 * the already-wired `appConfig.environment` rather than introducing a new env var.
 *
 * Production targets the live Stripe account; every other environment targets
 * test mode (`/test`). NOTE: dev and staging use Stripe *sandbox* accounts, so a
 * customer id may only resolve once the admin has the matching sandbox selected
 * in the Stripe dashboard. The link is authoritative in production.
 */
import { appConfig } from './env';

const STRIPE_DASHBOARD_HOST = 'https://dashboard.stripe.com';

/**
 * Build a deep-link to a customer in the Stripe dashboard. Live mode in
 * production; test mode in every other environment.
 */
export function stripeCustomerDashboardUrl(customerId: string): string {
  const base =
    appConfig.environment === 'production'
      ? STRIPE_DASHBOARD_HOST
      : `${STRIPE_DASHBOARD_HOST}/test`;
  return `${base}/customers/${customerId}`;
}
